import { render, staticRenderFns } from "./VenueMyAppointmentList.vue?vue&type=template&id=2ecbe93d&scoped=true&"
import script from "./VenueMyAppointmentList.vue?vue&type=script&lang=js&"
export * from "./VenueMyAppointmentList.vue?vue&type=script&lang=js&"
import style0 from "./VenueMyAppointmentList.vue?vue&type=style&index=0&id=2ecbe93d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecbe93d",
  null
  
)

export default component.exports